import axios from 'axios';

const API_BASE_URL = 'https://darkslateblue-eel-151368.hostingersite.com/api';

// إعداد axios instance
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  withCredentials: false, // مهم: غيّر إلى false لتجنب مشاكل CORS
});

// Interceptor للطلبات - إضافة التوكن تلقائياً
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor للردود - معالجة الأخطاء
axiosInstance.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response) {
      // خطأ من السيرفر
      if (error.response.status === 401) {
        // غير مصرح - مسح البيانات وإعادة التوجيه
        localStorage.removeItem('access_token');
        localStorage.removeItem('user');
        window.location.href = '/auth';
      }
      return Promise.reject(error.response.data);
    } else if (error.request) {
      // لم يتم استلام رد
      return Promise.reject({ message: 'تعذر الاتصال بالخادم' });
    } else {
      // خطأ في الإعداد
      return Promise.reject({ message: error.message });
    }
  }
);

// API العام
export const api = {
  get: (endpoint) => axiosInstance.get(endpoint),
  post: (endpoint, data) => axiosInstance.post(endpoint, data),
  put: (endpoint, data) => axiosInstance.put(endpoint, data),
  delete: (endpoint) => axiosInstance.delete(endpoint),
};

// مقالات API
export const articlesAPI = {
  getAll: () => api.get('/articles'),
  getOne: (id) => api.get(`/articles/${id}`),
  create: (data) => api.post('/articles', data),
  update: (id, data) => api.put(`/articles/${id}`, data),
  delete: (id) => api.delete(`/articles/${id}`),
  search: (query, category = 'الكل') => {
    const params = new URLSearchParams();
    if (query) params.append('q', query);
    if (category && category !== 'الكل') params.append('category', category);
    return api.get(`/articles/search?${params.toString()}`);
  },
};

// استشارات API
export const consultationsAPI = {
  getAll: () => api.get('/consultations'),
  getOne: (id) => api.get(`/consultations/${id}`),
  create: (data) => api.post('/consultations', data),
  update: (id, data) => api.put(`/consultations/${id}`, data),
  delete: (id) => api.delete(`/consultations/${id}`),
  search: (query) => {
    const params = new URLSearchParams();
    if (query) params.append('q', query);
    return api.get(`/consultations/search?${params.toString()}`);
  },
};

// مصادقة API
export const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
  logout: () => api.post('/auth/logout'),
  register: (data) => api.post('/auth/register', data),
  getProfile: () => api.get('/auth/profile'),
};

// إحصائيات API
export const statsAPI = {
  getStats: () => api.get('/stats'),
};

export default api;